import React from "react";
import ServicesAreaItem from "./ServicesAreaItem";

const ServicesArea = () => {
  const services_area_list = [
    {
      title: "Bank en Fauteuil Herstofferen",
      desc: "Vakkundig herstofferen van banken en fauteuils met hoogwaardige stoffen voor een tweede leven van uw meubels.",
      url: "/services-details",
      delay_time: 2,
      icon: "chesterfield_icon.png",
    },
    {
      title: "Stoelen en Eetkamerstoelen",
      desc: "Laat uw stoelen en eetkamerstoelen professioneel herstofferen voor optimaal comfort en een vernieuwde uitstraling.",
      url: "/services-details",
      delay_time: 4,
      icon: "chairs_icon.png",
    },
    {
      title: "Kantoorinrichting Stofferen",
      desc: "Herstoffering van bureaustoelen, banken en wachtmeubels voor bedrijven. Professioneel en duurzaam.",
      url: "/services-details",
      delay_time: 6,
      icon: "office_icon.png",
    },
    {
      title: "Projectstoffering voor Bedrijven",
      desc: "Complete stoffering van bedrijfsruimtes, horeca en kantoren met hoogwaardige materialen en maatwerkoplossingen.",
      url: "/services-details",
      delay_time: 8,
      icon: "project_icon.png",
    },
  ];
  

  return (
    <section className="services-area pt-35 pb-95">
      <div className="container">
        <div className="row justify-content-center">
          {services_area_list.map((item, index) => (
            <div key={index} className="col-xl-3 col-lg-4 col-md-6 col-sm-10">
              <ServicesAreaItem index={index} item={item} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesArea;
